import { render, staticRenderFns } from "./ReportDetailPage.vue?vue&type=template&id=43edd538&scoped=true&"
import script from "./ReportDetailPage.vue?vue&type=script&lang=js&"
export * from "./ReportDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./ReportDetailPage.vue?vue&type=style&index=0&id=43edd538&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43edd538",
  null
  
)

component.options.__file = "ReportDetailPage.vue"
export default component.exports